export const HELP_EMAIL = 'vadym.k@winwin.travel'
